import RestService from "./RestService";
import http from "superagent";

export default class ThemeService extends RestService {
    constructor() {
        super('themes')
    }

    listV2() {
        let url = this.baseUrl + '/api/v1/themes.json?v=2&t=' + Date.now()
        return this.executeGet(url)
    }

    myThemes() {
        let url = this.baseUrl + '/api/v1/user-themes.json?t=' + Date.now()
        return this.executeGet(url)
    }

    save(theme) {
        let request = {
            theme: {
                name: theme.name,
                css_framework: theme.css_framework,
                metadata: theme.metadata
            }
        }

        return theme.id === null ? this.create(request) : this.update(theme.id, request)
    }

    createPreview(theme) {
        let url = this.baseUrl + '/api/v1/create-theme-preview.json?t=' + Date.now()
        return new Promise((resolve, reject) => {
            http.post(url)
                .send(theme)
                .set('Accept', 'application/json')
                .end((error, response) => {

                    if (response.status === 200 || response.status === 201) {
                        resolve(JSON.parse(response.text))
                    } else {
                        reject(JSON.parse(response.text))
                    }
                })
        })
    }

    loadPreview() {
        let url = this.baseUrl + '/api/v1/theme-preview.css?t=' + Date.now()
        return new Promise((resolve, reject) => {
            http.get(url)
                .end((error, response) => {

                    if (response.status === 200 || response.status === 201) {
                        resolve(response.text)
                    } else {
                        reject(response.text)
                    }
                })
        })
    }
}